import { lighten, makeStyles, darken } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 8,
    padding: '4px 6px',
    margin: '2px 6px',
    display: 'inline-block',
    background:
      theme.palette.type === 'light'
        ? lighten(theme.palette.secondary.light, 0.8)
        : darken(theme.palette.secondary.light, 0.8)
  },
  warningRoot: { background: theme.palette.error.light },
  title: {
    fontWeight: 600,
    color: theme.palette.secondary.main
  },
  warningTitle: { color: theme.palette.error.main }
}))
export default useStyles
